<template>
  <main class="main-content">
    <div ref="intro" v-if="showIntro">
      <intro @ended="toggleIntro" ref="intro" />
    </div>
    <rapport />
    <numbers />
    <quiz />
    <results />
  </main>
</template>

<script>
import { mapMutations } from "vuex";
import Intro from "./Intro.vue";
import Rapport from "./Rapport.vue";
import Numbers from "./Numbers.vue";
import Quiz from "./Quiz.vue";
import Results from "./Results.vue";
import { vuexMutations } from "../store";

export default {
  name: "Content",
  data() {
    return {
      showIntro: true
    };
  },
  components: {
    Intro,
    Rapport,
    Numbers,
    Quiz,
    Results
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    ...mapMutations({ toggleLanguageNav: vuexMutations.TOGGLE_LANGUAGE_MENU }),
    toggleIntro() {
      const introHeight = this.$refs.intro.clientHeight;
      const currentScroll = window.scrollY;
      const newScrollValue = currentScroll - introHeight || 0;

      if (window.scrollY < introHeight) {
        try {
          window.scrollTo({
            top: introHeight,
            left: 0,
            behavior: "smooth"
          });
        } catch {
          window.scrollTo(0, currentScroll + introHeight);
        }
      }

      setTimeout(() => {
        this.showIntro = false;
        window.scrollTo(0, newScrollValue);
      }, 500);

      this.toggleLanguageNav();
    }
  }
};
</script>